export const ERROR_NEWCON_FORA_DO_AR = 'Timeout expired. The timeout period elapsed prior to completion of the operation or the server is not responding.'

export const ErrorsASeremSubstituidos = {
  [ERROR_NEWCON_FORA_DO_AR]: (newconError) => `Desculpe, o sistema está temporariamente indisponível. Por favor, entre em contato com a Área de Suporte. <br> Erro: ${newconError}`
}
